// Coder workspaces expose each forwarded dev port on its own subdomain:
//   https://<port>--<workspace>--<agent>--<user>.<coder-domain>
// CONFIG.apiUrl is baked in at build/server start (config-webpack), so it
// can only name one api origin. When the dashboard itself is served from
// a port-forward domain, derive the api origin at runtime by swapping the
// port prefix instead — one running server then works from localhost AND
// the Coder domain. Hosts that don't match the pattern (localhost,
// deployed domains) keep CONFIG.apiUrl.
const API_DEV_PORT = 3210;

export const deriveApiUrl = (
  host: string,
  protocol: string,
  fallback: string,
  detectLocalhost = false
): string => {
  const coder = host.match(/^\d+--(.+)$/);
  if (coder) return `${protocol}//${API_DEV_PORT}--${coder[1]}`;
  // Only `next dev` maps localhost to the local api — production builds
  // smoke-tested on localhost (yarn build && yarn start) and jsdom tests
  // must keep the configured origin.
  const local = detectLocalhost && host.match(/^(localhost|127\.0\.0\.1)(:\d+)?$/);
  if (local) return `http://${local[1]}:${API_DEV_PORT}`;
  return fallback;
};

export const getApiUrl = (): string => {
  if (typeof window === 'undefined') return CONFIG.apiUrl;
  return deriveApiUrl(
    window.location.host,
    window.location.protocol,
    CONFIG.apiUrl,
    process.env.NODE_ENV === 'development'
  );
};

export const prependApiUrl = (path: string): string =>
  path ? `${getApiUrl()}${path}` : null;

export const getDirectUploadUrl = (): string =>
  `${getApiUrl()}/rails/active_storage/direct_uploads`;

export const getBlobUrl = ({
  signedId,
  filename,
}: {
  signedId: string;
  filename: string;
}): string =>
  `${getApiUrl()}/rails/active_storage/blobs/${signedId}/${filename}`;
